import React from "react";
import icon1 from "../../images/icons/icon-01.svg";
import icon2 from "../../images/icons/icon-02.svg";
import icon3 from "../../images/icons/icon-3.svg";
import icon4 from "../../images/icons/icon-4.svg";
import join from "../../images/join1.png";

const updates = [
	{
		icon: icon1,
		text: "Login with your credentials to lodge a complaint about any hostel with the comment button",
	},
	{
		icon: icon2,
		text: "Only registered Hostels / Homestels under the Directorate of Student Affairs contacts may be displayed for booking enquiries",
	},
	{
		icon: icon3,
		text: "Obuasi-Campus students can now locate their hostels using the Obuasi Campus link",
	},
	{
		icon: icon4,
		text: "Use the FAQs and the Help Desk section for any other concerns",
	},
];

const ClassSection = () => {
	return (
		<section className="lp-section lp-section--tinted">
			<div className="container">
				<div className="lp-updates-grid">
					<div>
						<header className="lp-section-head lp-section-head--left">
							<span className="lp-kicker">What&apos;s New</span>
							<h2 className="lp-section-title">New Updates on KOSASS</h2>
							<p className="lp-section-text">
								We are thrilled to announce the release of an upgraded Student
								Accommodation Support System (KOSASS) designed exclusively for you.
								This new system aims to enhance and streamline the process of
								securing off-campus housing.
							</p>
						</header>
						<div className="lp-updates">
							{updates.map((item, i) => (
								<article key={i} className="lp-update">
									<span className="lp-update-icon">
										<img src={item.icon} alt="" />
									</span>
									<p>{item.text}</p>
								</article>
							))}
						</div>
					</div>
					<div className="lp-updates-art">
						<img src={join} alt="Students using KOSASS" className="img-fluid" />
					</div>
				</div>
			</div>
		</section>
	);
};

export default ClassSection;
